// Vendor Components
import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const AccordionContext = React.createContext({
    isExpanded: undefined,
    isForceExpanded: undefined,
    togglePanel: undefined,
});
